define('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyDayItemView',['require','view/controller/booking/datetime/slots/TimeSlotView'],function (require) {

    var Parent = require('view/controller/booking/datetime/slots/TimeSlotView');

    return Parent.extend({

        template: '#time_grid_weekly_day_item_view',
        
        serializeData: function () {
            var service = this.getOption('serviceModel');
            var provider = this.getOption('providerModel');
            
            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                'from_datetime': Date.parseMysqlDate(this.model.get('date') + ' ' + this.model.get('from')),
                'to_datetime': Date.parseMysqlDate(this.model.get('date') + ' ' + this.model.get('to')),
                'service': service && service.toJSON(),
                'provider': provider && provider.toJSON()
            });
        }

    });

});
